import { render, staticRenderFns } from "./MyLuckDrawTicket.vue?vue&type=template&id=f8f07d5c&scoped=true"
import script from "./MyLuckDrawTicket.vue?vue&type=script&lang=js"
export * from "./MyLuckDrawTicket.vue?vue&type=script&lang=js"
import style0 from "./MyLuckDrawTicket.vue?vue&type=style&index=0&id=f8f07d5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f07d5c",
  null
  
)

export default component.exports